/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Box, Divider, Grid, TextField, Typography } from '@mui/material';

import { IInstrumento } from '../../../services/api/dams/DamServices';
import { VSelectMonitoringFrequency } from '../../shared';
import { ColorsLimite } from '../../../environment';

interface VazaoProps {
	data: IInstrumento
	handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	validations: any;
	handleFrenquencyChange: (newFrequency: string) => void;
}

export const Vazao: React.FC<VazaoProps> = ({ data, handleChange, validations, handleFrenquencyChange }) => {

	return (
		<Box width={'100%'}>
			<Grid container direction={'column'} padding={2} spacing={2}>
				<Grid container item direction={'row'} spacing={2}>
					<Grid item xs={12}>
						<Typography variant='h5'>Dados do Instrumento</Typography>
					</Grid>
					<Grid item xs={12}>
						<Divider />
					</Grid>
					<Grid item xs={6}>
						<TextField
							fullWidth
							label={'Elevação'}
							id='elevacao'
							value={data.elevacao || ''}
							onChange={handleChange}
							type='number'
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							fullWidth
							label={'Tipo'}
							id='tipo'
							value={data.tipo || ''}
							onChange={handleChange}
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							fullWidth
							label={'Unidade de medida'}
							id='unidade_medida'
							value={data.unidade_medida || ''}
							onChange={handleChange}
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							fullWidth
							label={'Frequência de monitoramento'}
							id='freq_monit'
							value={data.freq_monit || ''}
							error={validations.freq_monit}
							onChange={handleChange}
							required
							type='number'
						/>
					</Grid>
					<Grid item xs={12}>
						<VSelectMonitoringFrequency
							initFrequency={data.freq_monit_medida || ''}
							onTypeChange={(newFrequency) => handleFrenquencyChange(newFrequency)}
						/>
					</Grid>
					<Grid item xs={12}>
						<Typography variant='h5'>Limites</Typography>
					</Grid>
					<Grid item xs={12}>
						<Divider />
					</Grid>
					<Grid item xs={6}>
						<TextField
							fullWidth
							label={'Limite Normal'}
							id='limite_faixa_verde'
							value={data.limite_faixa_verde || ''}
							onChange={handleChange}
							InputProps={{
								style: { backgroundColor: ColorsLimite.verde },
							}}
							InputLabelProps={{
								shrink: true,
								style: {
									WebkitTextStroke: '0.1px black',
									color: 'inherit',
								},
							}}
							type='number'
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							fullWidth
							label={'Limite Atenção'}
							id='limite_faixa_amarela'
							value={data.limite_faixa_amarela || ''}
							onChange={handleChange}
							type='number'
							InputLabelProps={{
								shrink: true,
								style: {
									WebkitTextStroke: '0.1px black',
									color: 'inherit',
								},
							}}
							InputProps={{
								style: { backgroundColor: ColorsLimite.amarelo },
							}}
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							fullWidth
							label={'Limite Alerta'}
							id='limite_faixa_laranja'
							value={data.limite_faixa_laranja || ''}
							onChange={handleChange}
							type='number'
							InputLabelProps={{
								shrink: true,
								style: {
									WebkitTextStroke: '0.1px black',
									color: 'inherit',
								},
							}}
							InputProps={{
								style: { backgroundColor: ColorsLimite.laranja },
							}}
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							fullWidth
							label={'Limite Emergência'}
							id='limite_faixa_vermelha'
							value={data.limite_faixa_vermelha || ''}
							onChange={handleChange}
							type='number'
							InputLabelProps={{
								shrink: true,
								style: {
									WebkitTextStroke: '0.1px black',
									color: 'inherit',
								},
							}}
							InputProps={{
								style: { backgroundColor: ColorsLimite.vermelho },
							}}
						/>
					</Grid>
				</Grid>
			</Grid>
		</Box>
	);
};